import { render, staticRenderFns } from "./ConfirmsPassword.vue?vue&type=template&id=f9fd5194&"
import script from "./ConfirmsPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmsPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports